const ios = {
    iosTopHeight (type) {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            return type === 'margin' ? 'marginHeight_64' : type === 'padding' ? 'paddingHeight_64' : 'topHeight_64'
        } else if (parseInt(iosHeight) === 88) {
            return type === 'margin' ? 'marginHeight_88' : type === 'padding' ? 'paddingHeight_88' : 'topHeight_88'
        } else {
            return ''
        }
    },
    fixedTop () {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            return 'fixedTop_64'
        } else if (parseInt(iosHeight) === 88) {
            return 'fixedTop_88'
        } else {
            return ''
        }
    },
    iosHeight () {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            return 'isIos'
        } else if (parseInt(iosHeight) === 88) {
            return 'isIos2'
        } else {
            return ''
        }
    },
    iosHeightDiv2 () {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            return 'isIosHeight'
        } else if (parseInt(iosHeight) === 88) {
            return 'isIosHeight2'
        } else {
            return ''
        }
    },
    iosHeightDiv () {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            return 'isIosHeight4'
        } else if (parseInt(iosHeight) === 88) {
            return 'isIosHeight3'
        } else {
            return ''
        }
    },
    routerMap (val) {
        const maps = new Map(
            [
                [1, '/b2b/order/myBank'],
                [2, '/b2b/payment/cashier'],
                [3, '/b2b/wallet/assets'],
                [4, '/b2b/wallet/topUps']
            ]
        )
        return maps.get(val)
    },
    // 控制价格显示
    isPriceShow () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        return userInfo && (userInfo.authenticationStatus === 3)
    },
    // 控制认证显示
    isApproveShow () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        return userInfo && (userInfo.authenticationStatus === 3)
    }
}

export default function install (Vue) {
    Vue.prototype.$iosHeight = ios.iosHeight
    Vue.prototype.$iosHeightDiv = ios.iosHeightDiv
    Vue.prototype.$iosHeightDiv2 = ios.iosHeightDiv2
    Vue.prototype.$routerMap = ios.routerMap
    Vue.prototype.$iosTopHeight = ios.iosTopHeight
    Vue.prototype.$fixedTop = ios.fixedTop
    Vue.prototype.$isPriceShow = ios.isPriceShow
    Vue.prototype.$isApproveShow = ios.isApproveShow
}